import { Controller } from '@hotwired/stimulus'

// Support a chevron that changes > or V when a collapse is shown or hidden
// Hooks into existing Bootstrap Collapse instance or creates a new one

export default class extends Controller {
    static targets = ['chevronOn', 'chevronOff', 'collapse']

    collapseTargetConnected() {
        this.bsCollapse = bootstrap.Collapse.getOrCreateInstance(this.collapseTarget, {
            toggle: false,
        })

        this.showHandler = this.show.bind(this)
        this.hideHandler = this.hide.bind(this)

        this.collapseTarget.addEventListener('show.bs.collapse', this.showHandler)
        this.collapseTarget.addEventListener('hide.bs.collapse', this.hideHandler)
    }

    collapseTargetDisconnected() {
        this.collapseTarget.removeEventListener('show.bs.collapse', this.showHandler)
        this.collapseTarget.removeEventListener('hide.bs.collapse', this.hideHandler)
    }

    show() {
        if (this.hasChevronOnTarget) this.chevronOnTarget.classList.remove('d-none')
        if (this.hasChevronOffTarget) this.chevronOffTarget.classList.add('d-none')
    }

    hide() {
        if (this.hasChevronOnTarget) this.chevronOnTarget.classList.add('d-none')
        if (this.hasChevronOffTarget) this.chevronOffTarget.classList.remove('d-none')
    }
}
